import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../../bindings/bao-date-time-box";
import "./../../../bindings/bao-searcher";
function ExpandedSearchConfigurationItem(parent) {
    var self = this;
    var htmlUrl = "Checkware/CheckwareExpandedSearch/ExpandedEvaluation";
    self.SearchModel = parent;
    self.InsertDateFrom = ko.observable();
    self.InsertDateTo = ko.observable();
    self.CompleteDateFrom = ko.observable();
    self.CompleteDateTo = ko.observable();
    self.Username = ko.observable();
    self.OrgUnitId = ko.observable();
    self.ChecklistName = ko.observable();
    self.ChecklistId = ko.observable();
    self.FieldId = ko.observable();
    self.FieldValue = ko.observable();
    self.FieldName = ko.observable();
    self.UserId = ko.observable();
    self.FullName = ko.observable();
    self.RoleId = ko.observable();
    self.InsertByUserId = ko.observable();
    self.FieldId.subscribe(function (id) {
        if (id == null) {
            self.FieldValue("");
        }
    });

    self.CustomFilter = ko.computed(function () {
        if (Bao.Utils.String.IsNullOrWhitespace(self.Username()) && self.InsertDateFrom() == null
            && self.InsertDateTo() == null
            && self.CompleteDateFrom() == null
            && self.CompleteDateTo() == null
            && Bao.Utils.String.IsNullOrWhitespace(self.OrgUnitId())
            && self.ChecklistId() == null
            && self.ChecklistName() == null
            && self.FieldId() == null
            && self.UserId() == null
            && self.FullName() == null
            && self.RoleId() == null
            && self.InsertByUserId() == null) {
            return null;
        }
        else {
            return {
                InsertDateFrom: self.InsertDateFrom(),
                InsertDateTo: self.InsertDateTo(),
                CompleteDateFrom: self.CompleteDateFrom(),
                CompleteDateTo: self.CompleteDateTo(),
                OrgUnitId: self.OrgUnitId(),
                ChecklistId: self.ChecklistId(),
                ChecklistName: self.ChecklistName(),
                FieldId: self.FieldId(),
                FieldValue: self.FieldValue(),
                UserId: JSON.stringify(self.UserId()),
                RoleId: JSON.stringify(self.RoleId()),
                InsertByUserId: JSON.stringify(self.InsertByUserId()),
                Username: self.Username()
            };
        }
    });
    self.FieldValue.subscribe(function () {
        parent.SearchTextEnabled(self.FieldValue() == "");
    });
    self.CustomFilter.subscribe(function () {
        parent.CustomFilter(self.CustomFilter());
    });
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.init = function () {
        return self.LoadHtml();
    };
}
export default ExpandedSearchConfigurationItem;